<div class="header-wrapper" [ngClass]="{ 'header-wrapper--solid': solid }">
  <div class="header">
    <div class="header__content">
      <app-logo></app-logo>

      <div class="header__content-navigation" *ngIf="showNavigation">
        <ng-container *ngIf="isDesktopNavigation; else mobileNav">
          <app-navigation></app-navigation>

          <app-auth-button (logout)="logout()"></app-auth-button>
        </ng-container>

        <ng-template #mobileNav>
          <div class="header__content-mobile-nav">
            <div *ngIf="user$ | async; else signIn" class="header__mobile-menu">
              <app-avatar
                role="button"
                (click)="openPrivateMenu()"
              ></app-avatar>

              <div
                class="header__mobile-menu-dropdown"
                *ngIf="isPrivateMobileMenuOpen"
              >
                <app-mobile-navigation-dropdown
                  [showLogout]="true"
                  [navigationItems]="privateNavigationItems"
                  (closeMenu)="closePrivateMenu()"
                  (logout)="logout()"
                >
                </app-mobile-navigation-dropdown>
              </div>
            </div>

            <ng-template #signIn>
              <app-button
                [buttonStyle]="BUTTON_STYLES.ACTION"
                [buttonSize]="'medium'"
                [routerLink]="'/auth'"
              >
                {{ "sign_in" | t }}
              </app-button>
            </ng-template>

            <div class="header__mobile-menu">
              <app-icon
                [name]="ICONS.MENU_01_24"
                role="button"
                class="p-2"
                (click)="openPublicMenu()"
              ></app-icon>

              <div
                class="header__mobile-menu-dropdown"
                *ngIf="isPublicMobileMenuOpen"
              >
                <app-mobile-navigation-dropdown
                  [navigationItems]="publicNavigationItems"
                  (closeMenu)="closePublicMenu()"
                >
                </app-mobile-navigation-dropdown>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
